/* =========================================================
 * bsl-avis.js — Avis clients 5 étoiles (07/10/2026)
 * Apparition + étoiles animées, « Lire l'avis complet », carrousel mobile.
 * Chargé par snippets/bsl-temoignages.liquid (peut être inclus plusieurs fois : garde-fou).
 * =======================================================*/
(function () {
  'use strict';
  if (window.__bslRvInit) { window.__bslRvInit(); return; }

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var io = (!reduce && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 }) : null;
  var ro = ('ResizeObserver' in window) ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) { if (e.target.__rvCheck) e.target.__rvCheck(); });
  }) : null;

  function setupMore(card) {
    var rest = card.querySelector('.bsl-rv__rest');
    var btn = card.querySelector('.bsl-rv__more');
    if (!rest || !btn) return;
    var label = btn.querySelector('span') || btn;
    rest.__rvCheck = function () {
      if (rest.classList.contains('is-open') || !rest.clientHeight) return;
      var over = rest.scrollHeight > rest.clientHeight + 4;
      btn.hidden = !over;
      rest.classList.toggle('is-clamped', over);
    };
    rest.__rvCheck();
    if (ro) ro.observe(rest);
    btn.addEventListener('click', function () {
      var open = !rest.classList.contains('is-open');
      if (open) {
        rest.style.maxHeight = rest.scrollHeight + 'px';
        rest.classList.add('is-open');
        label.textContent = 'Réduire';
        try { if (window.bslTrack) window.bslTrack('review_expand', { dir: card.getAttribute('data-dir') }); } catch (x) {}
      } else {
        rest.style.maxHeight = rest.scrollHeight + 'px';
        void rest.offsetHeight;
        rest.style.maxHeight = '';
        rest.classList.remove('is-open');
        label.textContent = "Lire l'avis complet";
      }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function setupDots(wrap, cards) {
    var list = wrap.querySelector('[data-rv-list]');
    var dots = wrap.querySelector('[data-rv-dots]');
    if (!list || !dots || cards.length < 2) return;
    var pad = function () { return parseFloat(getComputedStyle(list).paddingLeft) || 0; };
    var btns = cards.map(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', "Voir l'avis " + (i + 1) + ' sur ' + cards.length);
      b.addEventListener('click', function () { list.scrollTo({ left: c.offsetLeft - pad(), behavior: reduce ? 'auto' : 'smooth' }); });
      dots.appendChild(b);
      return b;
    });
    var raf = 0;
    var update = function () {
      raf = 0;
      var x = list.scrollLeft + pad(), best = 0, bestD = Infinity;
      cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft - x); if (d < bestD) { bestD = d; best = i; } });
      btns.forEach(function (b, i) { b.classList.toggle('is-active', i === best); b.setAttribute('aria-current', i === best ? 'true' : 'false'); });
    };
    list.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }

  function setupWrap(wrap) {
    if (wrap.__rv) return;
    wrap.__rv = true;
    var cards = Array.prototype.slice.call(wrap.querySelectorAll('.bsl-rv'));
    wrap.classList.add('rv-ready');
    if (io) { wrap.classList.add('rv-armed'); io.observe(wrap); }
    cards.forEach(setupMore);
    setupDots(wrap, cards);
  }

  window.__bslRvInit = function () {
    Array.prototype.forEach.call(document.querySelectorAll('.bsl-rv-wrap'), setupWrap);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.__bslRvInit);
  else window.__bslRvInit();
  window.addEventListener('resize', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.bsl-rv__rest'), function (r) { if (r.__rvCheck) r.__rvCheck(); });
  });
})();
